import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';

function Services() {
            const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='py-5'>
      <Container>
        <Row>
          <h3>{currentLocal.language==="English"?"Vision":"الرؤية"}</h3>
          <p>{currentLocal.language==="English"?"نسعى لجعل مدارسنا البيئة المثلى لتحقيق أهداف التربية الإسلامية، والتَّعليم الحديث والفَعَّال؛ من خلال:":"نسعى لجعل مدارسنا البيئة المثلى لتحقيق أهداف التربية الإسلامية، والتَّعليم الحديث والفَعَّال؛ من خلال:"}</p>
          {/* <p>{currentLocal.language==="English"?"Developing modern educational mechanisms to raise our children's standards in line with contemporary life.":"نسعى لجعل مدارسنا البيئة المثلى لتحقيق أهداف التربية الإسلامية، والتَّعليم الحديث والفَعَّال؛ من خلال:":" تطوير آليات التعليم الحديث لرفع مستويات أبنائنا في مزامنة الحياة المعاصرة."}</p> */}
        </Row>
      </Container>
    </div>
  )
}

export default Services